import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import WhatsappTemplates from "@/pages/Pages/Whatsapp/WhatsappTemplates.vue";
import WhatsappTemplate from "@/pages/Pages/Whatsapp/WhatsappTemplate.vue";
import WhatsappDetail from "@/pages/Pages/Whatsapp/WhatsappDetail.vue";
import WhatsappDetailInfo from "@/pages/Pages/Whatsapp/WhatsappDetailInfo.vue";
import WhatsappGroup from "@/pages/Pages/Whatsapp/WhatsappGroup.vue";
import WhatsappProviderTariffs from "@/pages/Pages/Whatsapp/WhatsappProviderTariffs.vue";
import WhatsappProviderTariff from "@/pages/Pages/Whatsapp/WhatsappProviderTariff.vue";
import WhatsappPartnerTariffs from "@/pages/Pages/Whatsapp/WhatsappPartnerTariffs.vue";
import WhatsappPartnerTariff from "@/pages/Pages/Whatsapp/WhatsappPartnerTariff.vue";
import WhatsappDetailIncoming from "@/pages/Pages/Whatsapp/WhatsappDetailIncoming.vue";
import WhatsappDetailIncomingInfo from "@/pages/Pages/Whatsapp/WhatsappDetailIncomingInfo.vue";
import WhatsAppGroupIncoming from "@/pages/Pages/Whatsapp/WhatsAppGroupIncoming.vue";
import WhatsappIncomingTariffs from "@/pages/Pages/Whatsapp/WhatsappIncomingTariffs.vue";
import WhatsappIncomingTariff from "@/pages/Pages/Whatsapp/WhatsappIncomingTariff.vue";

const whatsappMenu = {
  path: "/whatsapp",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/whatsapp/detail",
  name: "Whatsapp",
  children: [
    {
      path: "templates",
      name: "whatsapp_templates",
      components: { default: WhatsappTemplates },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.whatsapp.templates',
      },
    },
    {
      path: "templates/new",
      name: "whatsapp_templates_new",
      components: { default: WhatsappTemplate },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/templates",
        msgKey: 'menu.item.whatsapp.templates',
      },
    },
    {
      path: "templates/:id",
      name: "whatsapp_templates_edit",
      components: { default: WhatsappTemplate },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/templates",
        msgKey: 'menu.item.whatsapp.templates',
      },
    },
    {
      path: "detail",
      name: "whatsapp_detail",
      components: { default: WhatsappDetail },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.whatsapp.detail',
      },
    },
    {
      path: "detail/:id",
      name: "whatsapp_detail_info",
      components: { default: WhatsappDetailInfo },
      meta:{
        icon: "whatsapp",
        parentPath: "/whatsapp/detail",
        msgKey: 'menu.item.statistics.whatsapp.detail',
      },
    },
    {
      path: "group",
      name: "whatsapp_group",
      components: { default: WhatsappGroup },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.whatsapp.group'
      },
    },
    {
      path: "service_providers/tariffs",
      name: "whatsapp_provider_tariff",
      components: { default: WhatsappProviderTariffs },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.whatsapp.provider.tariff',
      },
    },
    {
      path: "service_providers/tariffs/new",
      name: "whatsapp_provider_tariff_new",
      components: { default: WhatsappProviderTariff },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/service_providers/tariffs",
        msgKey: 'menu.item.whatsapp.provider.tariff',
      },
    },
    {
      path: "service_providers/tariffs/:id",
      name: "whatsapp_provider_tariff_edit",
      components: { default: WhatsappProviderTariff },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/service_providers/tariffs",
        msgKey: 'menu.item.whatsapp.provider.tariff',
      },
    },
    {
      path: "partners/tariffs",
      name: "whatsapp_client_tariff",
      components: { default: WhatsappPartnerTariffs },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.whatsapp.clients.tariff',
      }
    },
    {
      path: "partners/tariffs/new",
      name: "whatsapp_client_tariff_new",
      components: { default: WhatsappPartnerTariff },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/partners/tariffs",
        msgKey: 'menu.item.whatsapp.clients.tariff',
      },
    },
    {
      path: "partners/tariffs/:id",
      name: "whatsapp_client_tariff_edit",
      components: { default: WhatsappPartnerTariff },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/partners/tariffs",
        msgKey: 'menu.item.whatsapp.clients.tariff',
      }
    },
    {
      path: "incoming_tariffs",
      name: "whatsapp_incoming_tariffs",
      components: { default: WhatsappIncomingTariffs },
      meta:{
        icon: "whatsapp",
        msgKey: 'menu.item.whatsapp.mo.routing'
      }
    },
    {
      path: "incoming_tariffs/new",
      name: "whatsapp_incoming_tariffs_new",
      components: { default: WhatsappIncomingTariff },
      meta: {
        icon: "whatsapp",
        parentPath: "/whatsapp/incoming_tariffs",
        msgKey: 'menu.item.whatsapp.mo.routing'
      },
    },
    {
      path: "incoming_tariffs/:id",
      name: "whatsapp_incoming_tariffs_edit",
      components: { default: WhatsappIncomingTariff },
      meta:{
        icon: "whatsapp",
        parentPath: "/whatsapp/incoming_tariffs",
        msgKey: 'menu.item.whatsapp.mo.routing'
      }
    },
    {
      path: "detail_incoming",
      name: "whatsapp_detail_incoming",
      components: { default: WhatsappDetailIncoming },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.whatsapp.mo.detail'
      }
    },
    {
      path: "detail_incoming/:id",
      name: "whatsapp_detail_incoming_info",
      components: { default: WhatsappDetailIncomingInfo },
      meta:{
        icon: "whatsapp",
        parentPath: "/whatsapp/detail_incoming",
        msgKey: 'menu.item.statistics.whatsapp.mo.detail'
      }
    },
    {
      path: "group_incoming",
      name: "whatsapp_group_incoming",
      components: { default: WhatsAppGroupIncoming },
      meta: {
        icon: "whatsapp",
        msgKey: 'menu.item.statistics.whatsapp.mo.group'
      }
    },
  ],
};

export default whatsappMenu;
